import { gql } from '../../../apollo/__generated__';

export const Targeted_USERS = gql(`
  query TargetedUsers($eventId: ID!) {
    targetedUsers(eventId: $eventId) {
      id
      firstname
      lastname
      nickname
      studies
      studyTown
      folklore
      targetCount(eventId: $eventId)
    }
  }
`);
